export const GET_MODULES_BEGIN = 'GET_MODULES_BEGIN'
export const GET_MODULES_SUCCESS = 'GET_MODULES_SUCCESS'
export const GET_MODULES_ERROR = 'GET_MODULES_ERROR'

export const CREATE_MODULE_BEGIN = 'CREATE_MODULE_BEGIN'
export const CREATE_MODULE_SUCCESS = 'CREATE_MODULE_SUCCESS'
export const CREATE_MODULE_ERROR = 'CREATE_MODULE_ERROR'

export const UPDATE_COMPANY_MODULE_BEGIN = 'UPDATE_COMPANY_MODULE_BEGIN'
export const UPDATE_COMPANY_MODULE_SUCCESS = 'UPDATE_COMPANY_MODULE_SUCCESS'
export const UPDATE_COMPANY_MODULE_ERROR = 'UPDATE_COMPANY_MODULE_ERROR'

export const CREATE_STORE_MODULE_BEGIN = 'CREATE_STORE_MODULE_BEGIN'
export const CREATE_STORE_MODULE_SUCCESS = 'CREATE_STORE_MODULE_SUCCESS'
export const CREATE_STORE_MODULE_ERROR = 'CREATE_STORE_MODULE_ERROR'

export const DELETE_STORE_MODULE_BEGIN = 'DELETE_STORE_MODULE_BEGIN'
export const DELETE_STORE_MODULE_SUCCESS = 'DELETE_STORE_MODULE_SUCCESS'
export const DELETE_STORE_MODULE_ERROR = 'DELETE_STORE_MODULE_ERROR'
